// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-request-list {
  padding: 7px 2px;
}
.job-request-list .business-unit-text {
  color: #6c757d;
}
.job-request-list .search-bar {
  margin-bottom: 8px;
}
.job-request-list .search-bar .search-input {
  width: 100%;
  font-size: 20px;
}
.job-request-list .expand-btn {
  width: 40px;
  height: 40px;
  line-height: 20px;
}
.job-request-list .job-row td {
  font-weight: 500;
}
.job-request-list th {
  background-color: #0066b2;
  color: #ffffff;
}
.job-request-list .detail-row {
  height: 0;
}
.job-request-list .detail-row td.detail-cell {
  padding: 0;
  border-bottom-width: 0;
}
.job-request-list .job-request-detail {
  overflow: hidden;
  padding: 4px 24px 8px 48px;
}
.job-request-list .sub-table {
  width: 100%;
  font-size: 0.875rem;
}
.job-request-list .sub-table th {
  white-space: nowrap;
  background-color: #0066b2;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home-page/job-request-list/job-request-list.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;AAHF;AAKE;EACE,cAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAMI;EACE,WAAA;EACA,eAAA;AAJN;AAQE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AANJ;AASE;EACE,gBAAA;AAPJ;AASE;EACI,yBC7BQ;ED8BR,cAAA;AAPN;AAUE;EACE,SAAA;AARJ;AAUI;EACE,UAAA;EACA,sBAAA;AARN;AAYE;EACE,gBAAA;EACA,0BAAA;AAVJ;AAaE;EACE,WAAA;EACA,mBAAA;AAXJ;AAaI;EACE,mBAAA;EACA,yBCrDQ;EDsDR,WAAA;AAXN","sourcesContent":["\n\n@use '../../../../styles/colors.scss' as colors;\n\n.job-request-list {\n  padding: 7px 2px;\n\n  .business-unit-text {\n    color: #6c757d;\n  }\n\n  .search-bar {\n    margin-bottom: 8px;\n\n    .search-input {\n      width: 100%;\n      font-size: 20px;\n    }\n  }\n\n  .expand-btn {\n    width: 40px;\n    height: 40px;\n    line-height: 20px;\n  }\n\n  .job-row td {\n    font-weight: 500;\n  }\n  th {\n      background-color: colors.$medium-blue;\n      color: #ffffff;\n    }\n\n  .detail-row {\n    height: 0;\n\n    td.detail-cell {\n      padding: 0;\n      border-bottom-width: 0;\n    }\n  }\n\n  .job-request-detail {\n    overflow: hidden;\n    padding: 4px 24px 8px 48px;\n  }\n\n  .sub-table {\n    width: 100%;\n    font-size: 0.875rem;\n\n    th {\n      white-space: nowrap;\n      background-color: colors.$medium-blue;\n      color: #fff;\n    }\n    \n  }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
